import { Flex } from '@chakra-ui/react'
import { IoArrowBack } from 'react-icons/io5'
import { useColorMode } from 'uikit/ColorMode/ColorMode'

export const BackButton = ({ onClick, ...props }) => {
  const { colorMode } = useColorMode()
  const themeBgHover = colorMode === 'light' ? 'gray.200' : 'gray.700'
  const themeBgActive = colorMode === 'light' ? 'gray.200' : 'gray.700'
  return (
    <Flex flex={1} {...props}>
      <Flex
        onClick={onClick}
        cursor="pointer"
        flex={1}
        transition="0.3s"
        _hover={{
          backgroundColor: themeBgHover,
        }}
        _active={{
          backgroundColor: themeBgActive,
        }}
      >
        <Flex height="104px" width="100%" alignItems="center" justifyContent="center">
          <IoArrowBack size="20px" />
        </Flex>
      </Flex>
    </Flex>
  )
}
